import { render } from "./DashboardList.vue?vue&type=template&id=4cf8c1fb&scoped=true"
import script from "./DashboardList.vue?vue&type=script&lang=js"
export * from "./DashboardList.vue?vue&type=script&lang=js"

import "./DashboardList.vue?vue&type=style&index=0&id=4cf8c1fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf8c1fb"]])

export default __exports__